import { call, put, select, takeEvery } from 'redux-saga/effects';
import ActionTypes from '../actions/actionTypes';
import { apiErrorsMessage, errorMessage } from '../actions/messageActions';
import { loadUserProfileSucceeded, updateSelectedUserType } from '../actions/userProfileActions';
import {
  getCreditIdentificationResponse,
  registerCreditIdentification,
  pairCreditIdentification,
} from '../api/creditIdentificationApi';
import { getUserProfile } from '../selectors/selectors';
import { BaseRoleCodes } from 'theme/constants';
import { getValidRoles, hasBaseRole } from 'auth/helper';

function getErrorAction(err) {
  if (err instanceof Error) {
    return errorMessage(err.message);
  }
  return apiErrorsMessage(err);
}

function* loadUserProfile(action) {
  try {
    if (!action || !action.payload) {
      throw new Error('Invalid action or payload');
    }

    const msalClaims = action.payload;
    const userProfile = {
      firstName: msalClaims['given_name'],
      lastName: msalClaims['family_name'],
      nxtEntityId: msalClaims['extension_NxtEntityId'],
    };

    const validUserRoles = getValidRoles(msalClaims['extension_CPURoles']);
    userProfile.roles = validUserRoles;
    yield put(loadUserProfileSucceeded(userProfile));
    yield setSelectedUserType(validUserRoles);
  } catch (err) {
    console.error('Error in loadUserProfile saga:', err);
    yield put(getErrorAction(err));
  }
}

function* setSelectedUserType(validUserRoles) {
  if (validUserRoles.length > 0) {
    var storedSelection = localStorage.getItem('selectedUserType');
    if (storedSelection && validUserRoles.includes(storedSelection)) {
      yield put(updateSelectedUserType(storedSelection));
    } else {
      yield put(updateSelectedUserType(validUserRoles[0]));
    }
  }
}

function* loadCreditIdentificationResponse() {
  try {
    const userProfile = yield select(getUserProfile);
    const hasTransporterRole = hasBaseRole(BaseRoleCodes.TRANSPORT_OPERATOR_CODE);
    if (hasTransporterRole) {
      yield call(getCreditIdentificationResponse, {
        nxtEntityId: userProfile.nxtEntityId,
      });
    }
  } catch (err) {
    yield put(getErrorAction(err));
  }
}

function* registerPaymentOption() {
  try {
    yield call(registerCreditIdentification);
  } catch (err) {
    yield put(getErrorAction(err));
  }
}

function* pairPaymentOption() {
  try {
    yield call(pairCreditIdentification);
  } catch (err) {
    yield put(getErrorAction(err));
  }
}

function* userProfileSaga() {
  yield takeEvery(ActionTypes.USER_PROFILE_REQUESTED, loadUserProfile);
  yield takeEvery(ActionTypes.CREDIT_IDENTIFICATION_REQUESTED, loadCreditIdentificationResponse);
  yield takeEvery(ActionTypes.REGISTER_PAYMENT_OPTION, registerPaymentOption);
  yield takeEvery(ActionTypes.PAIR_PAYMENT_OPTION, pairPaymentOption);
}

export default userProfileSaga;
